import hr_HR from '@src/components/common/antd/locale-provider/hr_HR';
// tslint:disable-next-line:no-submodule-imports
import sl_SI from 'antd/es/locale/sl_SI';

export const ANTDLOCALES = {
  hr: hr_HR,
  sl: sl_SI,
} as any;
